<template>
  <!--Page Header-->
  <section
    id="main-banner-page"
    class="position-relative page-header section-nav-smooth parallax blog-detail-header"
    :style="`background-image: url(${dataBerita.thumbnail});background-size: 100%;`"
  >
    <div class="overlay overlay-dark opacity-8 z-index-1"></div>
    <div class="container">
      <div class="row">
        <div class="col-lg-6 offset-lg-3">
          <div
            class="page-titles whitecolor text-center padding_top padding_bottom"
          >
            <h2 class="font-bold text-color-main">{{ dataBerita.title }}</h2>
          </div>
        </div>
      </div>
      <div class="gradient-bg title-wrap bg-custom">
        <div class="row">
          <div class="col-lg-12 col-md-12 whitecolor">
            <h3 class="float-left">Berita</h3>
            <ul class="breadcrumb top10 bottom10 float-right">
              <li class="breadcrumb-item"><a href="/">Beranda</a></li>
              <li class="breadcrumb-item">Berita</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--Page Header ends -->
  <!-- Our Blogs -->
  <section id="our-blog" class="bglight padding_top padding_bottom_half">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 col-md-7">
          <div class="news_item shadow-equal">
            <div class="image">
              <img
                :src="dataBerita.thumbnail"
                alt="Latest News"
                class="img-responsive"
              />
            </div>
            <div
              class="news_desc text-center text-md-left"
              style="
                background-color: #fff !important;
                background-image: none !important;
              "
            >
              <h3 class="text-capitalize font-normal darkcolor">
                <!-- <a href="">{{  }}</a> -->
                {{ dataBerita.title }}
              </h3>
              <ul class="meta-tags top20 bottom20">
                <li>
                  <a href="#."
                    ><i class="fas fa-calendar-alt"></i
                    >{{ dataBerita.created_at }}</a
                  >
                </li>
              </ul>
              <div v-html="dataBerita.content"></div>
              <!-- <p class="bottom35">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a
                galley.
              </p>
              <p class="heading_space">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
                nec facilisis nullano volutpat justo. Nulla tempus ultricies
                feugiat. Duis magna risus, luctus id urna dapibus condimentum
                dui. Maecenas tempor non ex eu vehicula. Sed sit placerat velit,
              </p>
              <blockquote class="blockquote darkcolor heading_space">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
              </blockquote>
              <ul class="rounded heading_space text-left">
                <li>
                  Lorem Ipsum has been the industry's standard dummy text ever
                </li>
                <li>
                  Lorem Ipsum has been the industry's standard dummy text ever
                </li>
                <li>
                  Lorem Ipsum has been the industry's standard dummy text ever
                </li>
                <li>
                  Lorem Ipsum has been the industry's standard dummy text ever
                </li>
                <li>
                  Lorem Ipsum has been the industry's standard dummy text ever
                </li>
              </ul> -->
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-5">
          <aside class="sidebar whitebox mt-5 mt-md-0">
            <div v-if="dataBerita.document != ''"
              class="widget shadow-equal heading_space_half text-center text-md-left"
            >
              <h4 class="text-capitalize darkcolor bottom20">
                Dokumen Pendukung
              </h4>
              <a
                target="_blank"
                :href="dataBerita.document"
                class="btn btn-sm btn-secondary w-100"
              >
                <i class="bi bi-file-earmark-arrow-down-fill"></i>
                Download PDF
              </a>
            </div>
            <div
              class="widget heading_space_half shadow-equal wow fadeIn"
              data-wow-delay="350ms"
            >
              <h4
                class="text-capitalize darkcolor bottom20 text-center text-md-left"
              >
                Berita Terbaru
              </h4>
              <div v-for="item in listRecent" :key="item" class="single_post d-table bottom15">
                <a :href="`/news-detail?prefix=${item.slug}`" class="post"
                  ><img
                  style="height: 100%; object-fit: cover;"
                    :src="getFilePath('news', item.thumbnail)"
                    alt="post image"
                /></a>
                <div class="text">
                  <a :href="`/news-detail?prefix=${item.slug}`">{{ item.title }}</a>
                  <span>{{ fomatDateTimeIndo(item.createdAt) }}</span>
                </div>
              </div>
            </div>
            <!-- <div
              class="widget shadow-equal heading_space_half text-center text-md-left"
            >
              <h4 class="text-capitalize darkcolor bottom20">K</h4>
              <ul class="webcats">
                <li>
                  <a href="#.">web design <span>(20)</span></a>
                </li>
                <li>
                  <a href="#.">network <span>(05)</span></a>
                </li>
                <li>
                  <a href="#.">marketing <span>(11)</span></a>
                </li>
                <li>
                  <a href="#.">event <span>(20)</span></a>
                </li>
                <li>
                  <a href="#.">website <span>(07)</span></a>
                </li>
                <li>
                  <a href="#.">themeforest<span>(19)</span></a>
                </li>
              </ul>
            </div>
            <div
              class="widget shadow-equal heading_space_half text-center text-md-left"
            >
              <h4 class="text-capitalize darkcolor bottom20">Tags</h4>
              <ul class="webtags">
                <li><a href="#.">web design</a></li>
                <li><a href="#.">network</a></li>
                <li><a href="#.">marketing</a></li>
                <li><a href="#.">posts</a></li>
                <li><a href="#.">event</a></li>
                <li><a href="#.">website</a></li>
                <li><a href="#.">social</a></li>
                <li><a href="#.">themeforest</a></li>
                <li><a href="#.">creative</a></li>
                <li><a href="#.">best solutions</a></li>
              </ul>
            </div> -->
          </aside>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useCmsStores } from "@/store/cms";
import { getFilePath } from "@/core/helpers/assets";
import { fomatDateTimeIndo } from "@/core/helpers/date";

export default defineComponent({
  setup() {
    const route = useRoute();
    const router = useRouter();
    const cmsStore = useCmsStores();
    const slug = route.query.prefix;
    const dataBerita = reactive({
      title: "",
      content: "",
      thumbnail: "",
      created_at: "",
      document: "",
    });

    onMounted(async () => {
      await getBerita();
      await getRecent();
    });

    const getBerita = async () => {
      await cmsStore
        .getNewsById(slug)
        .then((res) => {
          dataBerita.title = res.data.data.title;
          dataBerita.content = res.data.data.content;
          dataBerita.thumbnail = getFilePath("news", res.data.data.thumbnail);
          dataBerita.created_at = fomatDateTimeIndo(res.data.data.createdAt);
          if (res.data.data.document != null) {
            dataBerita.document = getFilePath(
              "news-doc",
              res.data.data.document
            );
          }
        })
        .catch((err) => {
          window.location.href = "/";
        });
    };

    const queryRecent = reactive({
      page: 1,
      limit: 5,
      sort : "desc",
      orderBy : "created_at",
      not_eq : slug,
      status : "published"
    });

    const listRecent = ref([]);
    const getRecent = async () => {
      await cmsStore.getNews(queryRecent).then((res) => {
        listRecent.value = res.data.data.data;
      });
    };

    return {
      dataBerita,
      listRecent,
      fomatDateTimeIndo,
      getFilePath,
    };
  },
});
</script>
